import React from 'react';
import {
  Box, Typography, makeStyles, Paper,
} from '@material-ui/core';
import gifSuccess from '../../../assets/img/marketPlace/Check_success.gif';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh',
    padding: theme.spacing(2),
  },
  succesCard: {
    backgroundColor: theme.body.successCard.backgroundColor,
    borderRadius: '20px',
    padding: theme.spacing(5),
    textAlign: 'center',
    maxWidth: '608px',
    height: '312px',
    width: '100%',
    boxShadow: `0px 10px 25px ${theme.body.successCard.boxShadow}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: {
    fontSize: '4.5rem',
    color: theme.body.successCard.icon,
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 700,
    color: theme.body.successCard.title,
    fontSize: 28,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    fontFamily: '"Karla"',
  },
  description: {
    color: theme.body.successCard.description,
    marginBottom: theme.spacing(5),
    fontSize: 20,
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontFamily: '"Karla"',
  },
}));

const Succesfull = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Paper elevation={0} className={classes.succesCard}>
        <img
          src={gifSuccess}
          alt="Succes icon"
          style={{
            width: 120,
            height: 120,
          }}
        />
        <Typography variant="h2" className={classes.title}>
          ¡Perfecto!
        </Typography>
        <Typography className={classes.description}>
          Asignaste tus certificados de manera exitosa.
        </Typography>
      </Paper>
    </Box>
  );
};

export default Succesfull;
